import { gql } from "@apollo/client";

export const SIGN_IN_GQL = gql`
  mutation GenerateCustomerToken($email: String!, $password: String!) {
    generateCustomerToken(email: $email, password: $password) {
      token
      expired_after_hours
    }
  }
`;

export const SIGN_UP_GQL = gql`
  mutation CreateCustomer($input: CustomerInput!) {
    createCustomer(input: $input) {
      customer {
        firstname
        lastname
        email
        date_of_birth
        is_subscribed
      }
    }
  }
`;

export const FORGOT_PASSWORD_GQL = gql`
  mutation RequestPasswordResetEmail($email: String!) {
    requestPasswordResetEmail(email: $email)
  }
`;

export const RESET_FORGOT_PASSWORD_GQL = gql`
  mutation ResetPassword(
    $email: String!
    $resetPasswordToken: String!
    $newPassword: String!
  ) {
    resetPassword(
      email: $email
      resetPasswordToken: $resetPasswordToken
      newPassword: $newPassword
    )
  }
`;

export const MERGE_CART_GQL = gql`
  mutation MergeCarts($guestCartId: String!, $customerCartId: String!) {
    mergeCarts(
      source_cart_id: $guestCartId
      destination_cart_id: $customerCartId
    ) {
      id
    }
  }
`;
